import { alpha } from "@mui/material/styles";

const styles = (theme) => {
	const escuro = theme.palette.mode === "dark";
	const verde = escuro
		? theme.palette.colors.green.light
		: theme.palette.colors.green.medium;

	return {
		container: {
			width: "100%",
			height: "100%",
			borderRadius: "10px",
			p: "20px",
			display: "flex",
			flexDirection: "column",
			gap: 2,
		},
		// Linha do cabeçalho: título/legenda à esquerda, botão ⓘ à direita.
		linhaCabecalho: {
			display: "flex",
			alignItems: "flex-start",
			justifyContent: "space-between",
			gap: 1,
		},
		cabecalho: {
			display: "flex",
			flexDirection: "column",
		},
		caption: {
			color: theme.palette.text.secondary,
		},
		// Lista vertical rolável: preenche o espaço restante do Paper (altura
		// fixa da linha vem da página, itemAlturaFeeds, compartilhada com a
		// TimelineGlobal ao lado) e rola por dentro.
		lista: {
			display: "flex",
			flexDirection: "column",
			gap: 1.5,
			flexGrow: 1,
			minHeight: 0,
			overflowY: "auto",
			pr: "6px",
		},
		skeletonItem: {
			width: "100%",
			minHeight: "84px",
			borderRadius: "10px",
		},
		itemLista: (cor) => ({
			display: "flex",
			flexDirection: "row",
			alignItems: "flex-start",
			gap: 1.5,
			p: "14px",
			borderRadius: "10px",
			border: `1px solid ${alpha(cor, escuro ? 0.35 : 0.3)}`,
			backgroundColor: alpha(cor, escuro ? 0.08 : 0.05),
		}),
		iconeCategoria: (cor) => ({
			color: cor,
			fontSize: "22px",
			mt: "1px",
		}),
		textosItem: {
			display: "flex",
			flexDirection: "column",
			minWidth: 0,
			flexGrow: 1,
		},
		tituloItem: {
			fontWeight: 600,
			fontSize: "0.9rem",
			lineHeight: 1.35,
			color: theme.palette.text.primary,
		},
		descricaoItem: {
			color: theme.palette.text.secondary,
		},
		botaoAcao: {
			flexShrink: 0,
			textTransform: "none",
			whiteSpace: "nowrap",
			color: theme.palette.text.primary,
			backgroundColor: theme.palette.action.hover,
			"&:hover": {
				backgroundColor: theme.palette.action.selected,
			},
		},
		estadoVazio: {
			flexGrow: 1,
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			gap: 0.5,
			textAlign: "center",
			py: 3,
		},
		iconeVazio: {
			color: verde,
			fontSize: "28px",
		},
		textoVazio: {
			color: theme.palette.text.secondary,
		},
	};
};

export default styles;
